import React, { useMemo } from 'react';

import { CanEditFormFieldsContext } from './can-edit-form-fields.context';

type CanEditFormFieldsProps = {
  isEditable: boolean;
  children: React.ReactNode;
};

// TODO: Can it inherit isEditable from a parent context if present
export const CanEditFormFields = ({ isEditable, children }: CanEditFormFieldsProps) => {
  const contextValue = useMemo(() => ({ isEditable }), [isEditable]);

  return (
    <CanEditFormFieldsContext.Provider value={contextValue}>
      {children}
    </CanEditFormFieldsContext.Provider>
  );
};
